module.exports = __webpack_public_path__ + "805e2d45037d300751331f7cbc963d42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzarsky-vycvik-3.jpg
// module id = 1192
// module chunks = 0